module.exports = __webpack_public_path__ + "static/media/quote1.e19cb0ca.png";